<template>
  <div class="indexPage">
    <homePage ref="homePage" />
  </div>
</template>

<script>
import homePage from "@/views/homePage/homePage";
export default {
  name: "index",
  components: { homePage },
  props: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
